import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedLineSelectTableConfig } from '@app/shared/models/shared-line-select-table-config.model';
import { PrimeNgModule } from '@app/shared/primeng/prime-ng.module';
import { LibPipeModule, TableColumn } from '@mynexus/mynexus-ui-lib';

@Component({
  selector: 'mnc-documents-shared-line-select',
  templateUrl: './shared-line-select.component.html',
  imports: [
    CommonModule,
    LibPipeModule,
    PrimeNgModule,
  ]
})
export class SharedLineSelectComponent {
  @Input() columns!: TableColumn[];
  @Input() lineData!: SharedLineSelectTableConfig[];
  @Input() isSingleSelect = false;
  @Output() selectedLines = new EventEmitter<string[]>();

  // When single selection, will just be a single item, but if multiselect or select all, then it will be an array.
  selected: SharedLineSelectTableConfig | SharedLineSelectTableConfig[];

  onRowSelect(): void {
    if (Array.isArray(this.selected)) {
      this.selectedLines.emit(this.selected.map(x => x.lineId));
    } else {
      this.selectedLines.emit([this.selected.lineId]);
    }
  }

  onRowUnselect(): void {
    this.selectedLines.emit([]);
  }

  onSelectAll(): void {
    const selectedArray = (this.selected || []) as SharedLineSelectTableConfig[];

    this.selectedLines.emit(selectedArray.map(x => x.lineId));
  }

  resetSelected(): void {
    this.selected = [];
    this.selectedLines.emit([]);
  }
}
